// extracted by mini-css-extract-plugin
export default {"box":"couponListPage_box__JeS4o"};